import React from "react";



function highlightMatch(text, keyword) {
  if (!text) return "";
  if (!keyword) return text;

  const idx = text.toLowerCase().indexOf(keyword.toLowerCase());
  if (idx === -1) return text;

  return (
    <>
      {text.slice(0, idx)}
      <strong>{text.slice(idx, idx + keyword.length)}</strong>
      {text.slice(idx + keyword.length)}
    </>
  );
}

export default function SuggestionList({
  suggestions,
  loading,
  keyword,
  highlightedIndex,
  onHover,
  onSelect,
}) {
  return (
    <>
      <style>{`
        .smart-search-suggestions-list {
          list-style: none;
          margin: 0;
          padding: 4px 0;
          max-height: 320px;
          overflow-y: auto;
          background: #fff;
          border: 1px solid #D5D9D9;
          border-radius: 4px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
          font-family: Arial, Helvetica, sans-serif;
        }

        .smart-search-suggestion-item {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          padding: 7px 12px;
          background: none;
          border: none;
          cursor: pointer;
          text-align: left;
          font-size: 14px;
          line-height: 1.3;
          color: #0F1111;
        }

        .smart-search-suggestion-item:hover,
        .smart-search-suggestion-item.highlighted {
          background-color: #F0F2F2;
        }

        .smart-search-suggestion-icon {
          flex-shrink: 0;
          color: #999;
        }

        .smart-search-suggestion-text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .smart-search-suggestion-text strong {
          font-weight: 700;
          color: #000;
        }

        .smart-search-suggestions-empty,
        .smart-search-suggestions-loading {
          background: #fff;
          border: 1px solid #D5D9D9;
          border-radius: 4px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
          font-family: Arial, Helvetica, sans-serif;
        }

        .smart-search-suggestions-empty {
          padding: 10px 12px;
          font-size: 13px;
          color: #6b6b6b;
        }

        .smart-search-suggestions-loading {
          padding: 4px 0;
        }

        .smart-search-skeleton-row {
          padding: 7px 12px;
        }

        .smart-search-skeleton-line {
          height: 12px;
          width: 70%;
          border-radius: 3px;
          background: linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%);
          background-size: 200% 100%;
          animation: smart-search-shimmer 1.2s infinite;
        }

        @keyframes smart-search-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      {loading ? (
        <div className="smart-search-suggestions-loading">
          {Array.from({ length: 5 }, (_, i) => i).map((i) => (
            <div key={i} className="smart-search-skeleton-row">
              <div className="smart-search-skeleton-line" />
            </div>
          ))}
        </div>
      ) : !suggestions || !suggestions.length ? (
        <div className="smart-search-suggestions-empty">
          No products found for &quot;{keyword}&quot;
        </div>
      ) : (
        <ul className="smart-search-suggestions-list" role="listbox">
          {suggestions.map((item, i) => {
            const label = item.name || item.description || item.product_name || item.title || "";
            if (!label) return null;

            return (
              <li key={`${item.id}-${i}`} role="presentation">
                <button
                  type="button"
                  role="option"
                  aria-selected={highlightedIndex === i}
                  className={`smart-search-suggestion-item${
                    highlightedIndex === i ? " highlighted" : ""
                  }`}
                  onMouseEnter={() => onHover(i)}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onSelect(item);
                  }}
                >
                  <svg
                    className="smart-search-suggestion-icon"
                    viewBox="0 0 20 20"
                    width="14"
                    height="14"
                    aria-hidden="true"
                  >
                    <circle
                      cx="8" cy="8" r="6"
                      fill="none" stroke="currentColor" strokeWidth="1.6"
                    />
                    <line
                      x1="12.5" y1="12.5" x2="17" y2="17"
                      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
                    />
                  </svg>
                  <span className="smart-search-suggestion-text">
                    {highlightMatch(label, keyword)}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}